import { SelectProduct, StylingStaff } from "../types/salon.types";

export const buildOrderData = ({
  customerId,
  staff,
  products,
  totals,
  customer,
  payment,
  discount,
  tips,
  time,
  outstandingBalance,
}: {
  customerId: string;
  staff: StylingStaff | null;
  products: SelectProduct[];
  totals: { subtotal: number; total: number };
  customer: { Name: string; phone_number: string };
  payment: { method: string; received: number; isFullPayment: boolean };
  discount: string;
  tips: string;
  time: any;
  outstandingBalance: number;
}) => {
  const now = new Date();
  return {
    customerId: customerId,
    // staffname: staff?.firstName,
    staffId: staff?._id.$oid,
    products: products.map((p) => ({
      productId: p._id.$oid,
      productName: p.productName,
      unitPrice: p.amount,
      arabicName: p.arabicName,
      quantity: p.quantity || 1,
      itemTotal: Number(p.amount) * Number(p.quantity),
    })),
    orderAmount: totals.subtotal.toFixed(2),
    finalAmount: totals.total.toFixed(2),
    orderDate: now.toISOString().split("T")[0],
    orderTime: now.toTimeString().split(" ")[0],
    discount,
    orderStatus: "Confirm",
    outstandingBalance: outstandingBalance,
    cancelOrderAmount: "0",
    remainingAmount: payment.method === "Buy on credit" ? totals.total.toFixed(2) : payment.isFullPayment ? "0" : (totals.total - payment.received).toFixed(2),
    payments: {
      paymentMethod: payment.method,
      receivedAmount: payment.method === "Buy on credit" ? "0" : payment.received.toFixed(2),
    },
    paymentHistory: [
      {
        paymentMethod: payment.method,
        receivedAmount: payment.method === "Buy on credit" ? "0" : payment.received.toFixed(2),
      },
    ],
    // customer,
    // tips,
    // changeDue: payment.method === "Buy on credit" ? "0" : payment.isFullPayment ? (payment.received - totals.total).toFixed(2) : "0",
    // paymentStatus: payment.method === "Buy on credit" ? "credit" : payment.isFullPayment ? "paid" : "partial",
  };
};
